<template>
    <div>
        <b-button
            variant="danger"
            @click.stop="confirmarDescomprometer()"
            v-if="tipo == 0"
        >
            <span
                ><i class="fa fa-times-circle-o mr-2"></i> Descomprometer
            </span>
        </b-button>
        <span class="text-danger" v-if="tipo == 1">
            <i
                class="fa fa-times-circle-o fa-lg icon-button"
                title="Descomprometer"
                @click.stop="confirmarDescomprometer()"
            ></i>
        </span>
    </div>
</template>

<script>
import ComprometimentosServicos from './ComprometimentosServicos'

export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        tipo: {
            type: Number,
            default: () => 0
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDescomprometer() {
            this.$swal({
                title: 'Descomprometimento',
                html: `Confirma a realização do descomprometimento de id ${this.comprometimento.chaveOrigem} 
                (${this.comprometimento.idRm}) do contrato ${this.contrato.vcCodigoEstruturado} no RM?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.descomprometer()
                }
            })
        },

        descomprometer() {
            this.$store.dispatch('addRequest')
            let descomprometimentoDto = {
                idContrato: this.contrato.idContrato,
                idComprometimentoRequisicao: this.comprometimento
                    .idComprometimentoRequisicao
            }
            ComprometimentosServicos.descomprometer(descomprometimentoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Descomprometido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit(
                                'atualizarComprometimento',
                                response.data
                            )
                        } else {
                            this.$emit('atualizarErros', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
